module.exports = {
  BASE_URL: "http://localhost:8001",
  BASE_URL_NODE_API: "http://localhost:3000",
  BASE_URL_FAST_API: "http://localhost:8002",
  BASE_URL_BFF: "http://localhost:8000",
  URL: 'http://localhost:8081' ,
  // WS_URL: "ws://localhost:8001",
  DEBUG_MODE: true,
  SECRET_KEY:'7f7af340a5588713bf9f691fdd4d9704f5e8da8e6587b8cdd7dafbc4a5a75c97',
  SITE_KEY:"6LfZeyoqAAAAAKPoqrXeMGNy_d195EjD5hAfmmis",
  // SITE_KEY:"6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI", // para localhost

  // para apuntar a QA
  // BASE_URL_BFF: "https://migps-bff.kausana.cl",
  WS_URL: "wss://migps-backend-ws.kausana.cl",

};